module.exports = __webpack_public_path__ + "static/media/profile.f48f3d6b.svg";